import React from 'react';

import How from './how';

export default React.memo(How);
